import { resolveImagePath } from '@/utils/imageMap';

export function Hero() {
  const heroBgUrl = resolveImagePath('/images/hero-bg.jpg');

  return (
    <section 
      className="relative min-h-[600px] bg-cover bg-center bg-no-repeat flex items-center"
      style={{ backgroundImage: `url(${heroBgUrl})` }}
    >
      {/* Overlay for better text readability */}
      <div className="absolute inset-0 bg-black bg-opacity-30"></div>
      
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-8 items-center">
          {/* Hero Text Content */}
          <div className="space-y-6">
            <div>
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-2">
                Learn to Fly Now
              </h1>
              <h2 className="text-xl md:text-2xl lg:text-3xl text-white font-light">
                at American Aviation Flight Academy
              </h2>
            </div>
            
            {/* Primary CTA Button */}
            <div>
              <a
                href="/contact-us"
                className="inline-flex items-center px-8 py-3 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg shadow-lg transition-colors duration-200"
              >
                <span>Start Now</span>
              </a>
            </div>
          </div>

          {/* Video Embed */}
          <div className="relative">
            <div className="aspect-video rounded-lg overflow-hidden shadow-2xl">
              <iframe
                title="American Aviation RD4"
                src="https://www.youtube.com/embed/YjYN5s6bXAQ?controls=1&rel=0&playsinline=1&cc_load_policy=0&autoplay=0&enablejsapi=1"
                className="w-full h-full"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}